import {ApiRequest} from "@gongt/ts-stl-library/request/protocol";

export interface UserQuery {
	email?: string;
	userId?: string;
	token?: string;
}
export interface UserQueryRequest extends UserQuery, ApiRequest {
	_userQuery?: any;
}
